import { any } from "prop-types";
import React, { useRef, useState } from "react";
import { H3GigaTitle } from "../texts";
import { VideoWrapperSettings } from "./components";
import { deviceType } from "../../utils";

export const FullWidthVideo = ({
  previewImage,
  className,
  isImage = true,
  srcVideo,
  srcVideoMobile,
  title = "Play video",
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const video = useRef(null);

  const isDesktop = deviceType() === "desktop";

  // 👉 desktop → srcVideo
  // 👉 mobile → srcVideoMobile (se esiste)
  const selectedVideo =
    !isDesktop && srcVideoMobile ? srcVideoMobile : srcVideo;

  const handlePlay = async () => {
    if (!video.current) return;

    try {
      // 1️⃣ parte sempre muted (policy browser)
      video.current.muted = true;
      await video.current.play();

      // 2️⃣ SUBITO DOPO lo sblocchiamo
      video.current.muted = false;
      video.current.volume = 1;

      document.body.style.overflow = "hidden";
      setIsPlaying(true);
    } catch (err) {
      console.error("❌ Video play error:", err);
    }
  };

  const handlePause = () => {
    if (!video.current) return;
    video.current.pause();
    document.body.removeAttribute("style");
    setIsPlaying(false);
  };

  return (
    <VideoWrapperSettings
      onClick={!isPlaying ? handlePlay : handlePause}
      className={`${className} full-width-video-wrapper ${
        isPlaying ? "start" : ""
      }`}
      style={
        isImage
          ? { backgroundImage: `url("${previewImage}")` }
          : { background: previewImage }
      }
    >
      {/* chiudi solo su mobile */}
      {!isDesktop && isPlaying && (
        <div className="close-video">&times;</div>
      )}

      <video
        ref={video}
        width="100%"
        preload="metadata"
        playsInline
        muted // 👈 NECESSARIO per farlo partire
      >
        <source src={selectedVideo} type="video/mp4" />
      </video>

      {!isPlaying && (
        <H3GigaTitle style={{ textAlign: "center" }}>
          {title}
        </H3GigaTitle>
      )}
    </VideoWrapperSettings>
  );
};

FullWidthVideo.propTypes = {
  previewImage: any,
  isImage: any,
  srcVideo: any,
  srcVideoMobile: any,
  title: any,
};